export default __webpack_public_path__ + "static/media/Image-10.d5e76d8d.jpg";